import { changeLocale } from "gatsby-plugin-intl-sushishop";
import React from "react";
import "./styles.module.scss";
import usePageLang from "@src/hooks/usePageLang";
import useLanguages from "./useLanguages";
import Select from "design-system/src/Form/Select/Select";

const LangSwitcher = () => {
  const currentLang = usePageLang();
  const { languages } = useLanguages();

  const handleChangeLang = (lang: string) => {
    changeLocale(lang, undefined, true);
  };

  return (
    <div
      className={"list__container"}
      style={{
        display: languages.length > 1 ? "block" : "none",
      }}
    >
      <Select
        value={currentLang}
        onChange={handleChangeLang}
        options={languages.map((item) => ({
          value: item.value,
          label: item.label,
        }))}
      />
    </div>
  );
};

export default LangSwitcher;
